import axios, { AxiosError, type AxiosResponse } from "axios";
import NotificationUtil from "@/utils/NotificationUtil";

const errorInterceptor = () => {
  axios.interceptors.response.use(
    async (response) => {
      return response;
    },
    (error: AxiosError) => {
      const { data, status } = error.response as AxiosResponse;
      switch (status) {
        case 400:
          if (data.errors) {
            const modalStateErrors = [];
            for (const key in data.errors) {
              if (data.errors[key]) {
                modalStateErrors.push(data.errors[key]);
              }
            }
            const errorFlat = modalStateErrors.flat().toString();
            NotificationUtil.notify400(errorFlat);
          } else if (data instanceof Blob) {
            data.text().then((errorMsg) => {
              NotificationUtil.notify400(errorMsg);
            });
          } else {
            NotificationUtil.notify400(data);
          }
          break;
        case 401:
          NotificationUtil.notify401(data);
          break;
        case 403:
          NotificationUtil.notify403(data);
          break;
        case 404:
          NotificationUtil.notify404(data);
          break;
        case 500:
          NotificationUtil.notify500("Server-Error");
          break;
      }
      return Promise.reject(error);
    }
  );
};

export default errorInterceptor;
